export default __webpack_public_path__ + "static/media/20.e366b767.png";